export class DashboardDetails
{
    //SupplierId?:any;
    EngagementId:any;
    ContractId:any;
    exportfor:string="";
    kpiPeriod:string="";
    year:any;

}